<template>
  <div class="page page-with-bg login-page">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>API Keys</h1>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <v-form-group label="Client Id">
            <b-form-input class="api-input"
                          v-model="apiKeys.clientId"
                          placeholder="Client Id" 
                          disabled />
          </v-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 d-flex align-items-center">
          <v-form-group class="col-10 pl-0" label="Client Secret">
            <b-form-input class="api-input"
                          v-model="apiKeys.clientSecret"
                          placeholder="Client Secret"
                          disabled />
          </v-form-group>
          <b-btn class="refresh-button"
                 variant="light"
                 @click="regenerate()"><svg-icon name="refresh"></svg-icon></b-btn>
        </div>
      </div>
      <div class="col-12 col-md-6 save-text" v-if="isRegenerated">
        Copy and save client secret!
      </div>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  const { mapState, mapActions } = createNamespacedHelpers('client');

  export default {

    data() {
      return {
        isRegenerated: false,
      };
    },

    computed: {
      ...mapState(['apiKeys'])
    },

    async created() {
      await this.loadApiKeys(this.$auth.userInfo.sub);
    },

    methods: {
      ...mapActions(["regenerateApiKeys", "loadApiKeys"]),
      async regenerate() {
        await this.regenerateApiKeys(parseInt(this.$auth.userInfo.sub));

        this.isRegenerated = true;
        this.$root.successToast("Client secret regenerated!");
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/styles/_mixins';

  .api-input:disabled {
    background-color: #fff !important;
    border-color: #ccc !important;
    cursor: default !important;
  }

  .refresh-button {
    border-radius: .5rem;
    width: 100%;
    border-color: #ccc;
    height: 3.8rem;

    .svg-icon {
      margin: 0;
      scale: 1.7;
    }
  }

  .save-text {
    color: red;
    font-weight: bold;
  }

  .page {
    @include retina('/png/coffee.png');
  }
</style>